import { Package, Truck } from "lucide-react";

// Function to determine delivery status
export const determineDeliveryStatus = (order) => {
  if (!order.shipment_details) return null;
  const { type, status } = order.shipment_details;
  
  // Не показываем для заказов после доставки/отмены
  if (['delivered', 'cancelled'].includes(order.status)) {
    return null;
  }
  
  if (type === 'self_pickup') {
    return { status: 'self_pickup', icon: Package, color: 'text-green-600' };
  }
  
  if (['cdek_delivery_point', 'cdek_courier'].includes(type) && order.status == 'ordered') {
    return { status: 'metaship_order_is_pending', icon: Truck, color: 'text-green-600' };
  }
  
  if (status === 'metaship_order_created') {
    return { status: 'metaship_success', icon: Truck, color: 'text-green-600' };
  }
  
  if (status === 'metaship_order_creation_failed') {
    return { status: 'metaship_order_is_failed', icon: Truck, color: 'text-red-600' };
  }
  
  return { status: 'metaship_order_is_pending', icon: Truck, color: 'text-yellow-600' };
};
